import React from 'react';
import { Route, Switch, withRouter } from "react-router-dom";
import AdminDashboard from './AdminDashboard';
import ManageMembers from './ManageMembers';
import PetsMember from './PetsMember';
import CallsReport from './CallsReport';
import CallsMember from './CallsMember';
import TransactionsReport from './TransactionsReport';
import TransactionsMember from './TransactionsMember';

function Admin({ match }) {
    return (
        <div>
            <Switch>
                <Route exact path={`${match.path}`} component={AdminDashboard} />                
                <Route path={`${match.path}/manage-members`} component={ManageMembers} />
                <Route path={`${match.path}/pets-member`} component={PetsMember} />                
                <Route path={`${match.path}/calls-report`} component={CallsReport} />
                <Route path={`${match.path}/calls-member`} component={CallsMember} />
                <Route path={`${match.path}/transactions-report`} component={TransactionsReport} />
                <Route path={`${match.path}/transactions-member`} component={TransactionsMember} />
            </Switch>
        </div>
    )
}

export default withRouter(Admin);